/**
 * Where the Outbox lives.
 *
 * ## It goes where a folder goes
 *
 * `/mail/outbox`, in the folder list, directly under Drafts. It is not a server
 * folder and never will be — the messages in it exist only on this device —
 * but "where a folder would be" is the only place a user will look for it, and
 * the point of a queue is that the user can find it. Drafts is its neighbour
 * for the same reason: Drafts is "written, not sent", the Outbox is "sent, not
 * gone", and they are the two places a message can be while it is still the
 * user's problem.
 *
 * A static segment, so react-router ranks it above `mail/:folderId` — the same
 * arrangement the unified view uses (`routes/mail/unifiedRoute.ts`). The id is
 * spelled once, here, because the router, the sidebar, the handheld drawer and
 * the banner's link all need it and a second spelling is a dead link.
 *
 * A real folder called "outbox" cannot collide with it: folder ids on the wire
 * are opaque and base64-ish (ADR 0012), never a bare lowercase word, and the
 * sidebar matches on this constant rather than on a name.
 */

export const OUTBOX_SEGMENT = 'outbox';
export const OUTBOX_PATH = `/mail/${OUTBOX_SEGMENT}`;

/** The value `selectedFolderId` takes while the Outbox is open. */
export const OUTBOX_FOLDER_ID = OUTBOX_SEGMENT;

export const OUTBOX_LABEL = 'Outbox';

export function isOutboxPath(pathname: string): boolean {
  return pathname === OUTBOX_PATH || pathname.startsWith(`${OUTBOX_PATH}/`);
}
